package com.appcreator.compose.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Modifier
import com.appcreator.blueprint.components.EnvComponent
import com.appcreator.blueprint.core.Component
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.core.ReadonlyEnvStore
import com.appcreator.compose.LocalEnvStore

@Composable
fun EnvComponentComposable(modifier: Modifier, component: EnvComponent) {
    val envStore = LocalEnvStore.current
    component.content?.value?.let { value ->
        (envStore.get(value) as? Component)?.let {
            ComponentComposable(modifier, it)
        }
    }
}